var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('ShareledgerSpecification',_vm._b({attrs:{"creation":""}},'ShareledgerSpecification',{
            ..._vm.$props,
            editable: !_vm.shareledger || !_vm.shareledger.addtoken_tx
        },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }